
//Dev Environment
//export const xMerckApiKey = 'yH7a6Gzqz7BPI1KWV5A9T9WbJ1GpHGzM';
//Production Environment
export const xMerckApiKey = 'ePvBdIsFy74DevyHiThQNAgnPjolpcjU';
